"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIFullscreenTakeoverSerialization = void 0;
class ChargerUIFullscreenTakeoverSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.expires_at = entity.expires_at
            ? entity.expires_at.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.expires_at = entity.expires_at
            ? new Date(entity.expires_at / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargerUIFullscreenTakeoverSerialization = ChargerUIFullscreenTakeoverSerialization;
